const copyUri = () => {
    const link = $('.copy-link');

    async function copyCode() {
        try {
            await navigator.clipboard.writeText(link.attr('href'));
        } catch (e) {
            console.log('The connection must be from a secure origin.' , e);
        }
    }

    link.on('click', (ev) => {
        ev.preventDefault();
        copyCode()
    })
}

export default copyUri;